import React from 'react';
import { XIcon } from 'lucide-react';
export function PainSection() {
  return <section className="bg-[#0B211A] py-4 md:py-5 px-3 border-b border-[#1F3D2B]" data-id="element-117">
      <div className="max-w-2xl mx-auto" data-id="element-118">
        <h2 className="text-xl md:text-2xl font-black text-[#FFFFFF] mb-3 text-center leading-tight tracking-tight" data-id="element-119">
          Si enseñás en escuela rural… esto te pasa.
        </h2>

        <div className="bg-[#102A1F] border border-[#1F3D2B] rounded p-3 md:p-4 shadow-md" data-id="element-120">
          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-2 leading-snug text-center" data-id="element-121">
            Terminás una clase… y ya tenés que pensar la siguiente.
          </p>
          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-2 leading-snug text-center" data-id="element-122">
            Buscás contenido ambiental… pero todo es:
          </p>

          <div className="flex justify-center gap-4 mb-3" data-id="element-123">
            <span className="text-[#BFC9C5] text-sm font-bold flex items-center gap-1" data-id="element-124">
              <XIcon className="w-3.5 h-3.5 text-[#8B2E2E]" strokeWidth={4} data-id="element-125" />{' '}
              Muy teórico
            </span>
            <span className="text-[#BFC9C5] text-sm font-bold flex items-center gap-1" data-id="element-126">
              <XIcon className="w-3.5 h-3.5 text-[#8B2E2E]" strokeWidth={4} data-id="element-127" />{' '}
              Urbano
            </span>
            <span className="text-[#BFC9C5] text-sm font-bold flex items-center gap-1" data-id="element-128">
              <XIcon className="w-3.5 h-3.5 text-[#8B2E2E]" strokeWidth={4} data-id="element-129" />{' '}
              Poco aplicable al campo
            </span>
          </div>

          <p className="text-sm md:text-base text-[#BFC9C5] font-medium mb-3 leading-snug text-center" data-id="element-130">
            Intentás adaptarlo. Intentás hacerlo práctico. Intentás conectar con
            la realidad de tus alumnos… Pero nunca termina de cerrar. Y al
            final…
          </p>

          <div className="bg-[#8B2E2E]/20 border-l-4 border-[#8B2E2E] p-2 mb-3" data-id="element-131">
            <p className="text-base md:text-lg font-black text-[#8B2E2E] text-center uppercase" data-id="element-132">
              👉 Terminás improvisando.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3" data-id="element-133">
            {['No tenés material ambiental aplicado al contexto rural', 'Todo lo tenés que adaptar vos', 'Perdés horas todas las semanas', 'No sabés cómo llevar la teoría a la práctica'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#071A14] p-2 rounded border border-[#1F3D2B]" data-id="element-134">
                <XIcon className="w-4 h-4 text-[#8B2E2E] flex-shrink-0" strokeWidth={4} data-id="element-135" />
                <span className="text-[#BFC9C5] font-bold text-xs md:text-sm leading-tight" data-id="element-136">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-[#BFC9C5] font-medium mb-2 text-center" data-id="element-137">
            Y eso no solo te consume tiempo…
          </p>

          <div className="bg-[#071A14] rounded p-2 text-center mb-3 border border-[#D4A843]/30" data-id="element-138">
            <p className="text-[#D4A843] font-black text-sm md:text-base uppercase" data-id="element-139">
              👉 Te hace enseñar por debajo de tu nivel.
            </p>
          </div>

          <p className="text-lg md:text-xl font-black text-[#FFFFFF] text-center leading-tight" data-id="element-140">
            ❗ ¿Cuántas clases más vas a seguir improvisando?
          </p>
        </div>
      </div>
    </section>;
}